import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { globalStyles, noop } from "@client/shared/constants";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import style from "./style";

const DefaultCallerIdView = ({
  defaultCallerIdName = "",
  defaultCallerIdNumber = "",
  handleChange = noop,
  phoneNumberList = [],
  handleSubmit = noop,
  errors = {},
  isFormValid = false,
}) => {
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            ...style.pageTitleWrapper,
          }}
        >
          <Typography variant="h6">Default Override Caller ID</Typography>
          <Typography
            variant="body2"
            sx={{
              ...globalStyles.text.color.secondaryText,
            }}
          >
            Set the Default Override Caller ID.
          </Typography>
        </Paper>
        <Paper elevation={0}>
          <Box
            sx={{
              mt: 2,
              p: 4,
              ...globalStyles.display.flex,
              ...globalStyles.width["50"],
            }}
          >
            <Box
              sx={{
                mr: 1,
                ...globalStyles.width["50"],
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  ...globalStyles.text.weight.bold,
                }}
              >
                Caller ID Name
              </Typography>
              <TextField
                error={!!(errors?.defaultCallerIdName || "").trim()}
                helperText={errors?.defaultCallerIdName}
                fullWidth
                size="small"
                placeholder="Name..."
                name="defaultCallerIdName"
                value={defaultCallerIdName}
                onChange={handleChange}
              />
            </Box>
            <Box
              sx={{
                ml: 1,
                ...globalStyles.width["50"],
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  ...globalStyles.text.weight.bold,
                }}
              >
                Caller ID Number
              </Typography>
              <Autocomplete
                fullWidth
                size="small"
                value={defaultCallerIdNumber}
                options={phoneNumberList}
                getOptionLabel={(option) => option.phoneNumber || ""}
                onChange={(evt, value) => {
                  handleChange({
                    currentTarget: {
                      name: "defaultCallerIdNumber",
                      value,
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Number"
                    error={!!(errors?.defaultCallerIdNumber || "").trim()}
                    helperText={errors?.defaultCallerIdNumber}
                  />
                )}
              />
              <Box sx={{ display: "flex", justifyContent: "end" }}>
                <Button
                  disabled={isFormValid}
                  onClick={handleSubmit}
                  sx={{ marginTop: "64px" }}
                  variant="contained"
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default DefaultCallerIdView;
